import React, { useState, useEffect } from 'react';
import { I18n } from '../../../helpers/i18n';
import SessionRatingModal from './SessionRatingModal';
import './RatingPromoteBanner.css';

function RatingPromoteBanner({ sessionId, onRatingSuccess, isBuddy = false, openModalSignal = 0 }) {
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [hoverStar, setHoverStar] = useState(0);
  const [initialScore, setInitialScore] = useState(0);
  const prefix = isBuddy ? 'buddy' : 'senior';

  useEffect(() => {
    if (openModalSignal > 0) {
      setInitialScore(0);
      setShowRatingModal(true);
    }
  }, [openModalSignal]);

  const handleStarClick = (star) => {
    setInitialScore(star);
    setShowRatingModal(true);
  };

  return (
    <>
      <div className="rating-promote-banner">
        <p className="rating-promote-banner-title">{I18n.t(`${prefix}_rate_session_title`)}</p>
        <p className="rating-promote-banner-description">{I18n.t(`${prefix}_rate_session_description`)}</p>
        <div className="rating-promote-banner-stars">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              className={`rating-promote-banner-star ${hoverStar >= star ? 'active' : ''}`}
              onClick={() => handleStarClick(star)}
              onMouseEnter={() => setHoverStar(star)}
              onMouseLeave={() => setHoverStar(0)}
              aria-label={`${star} sao`}
            >
              ☆
            </button>
          ))}
        </div>
      </div>

      <SessionRatingModal
        visible={showRatingModal}
        sessionId={sessionId}
        initialScore={initialScore}
        onClose={() => {
          setShowRatingModal(false);
          setInitialScore(0);
        }}
        onSuccess={onRatingSuccess}
        isBuddy={isBuddy}
      />
    </>
  );
}

export default RatingPromoteBanner;
